import React, { useState } from "react";
import { clientDb, keyGen } from "../../../../../shared/firebase";
import Modal from "../../../../Modal";
import styles from './CreateNewGroupModal.module.scss';

const CreateNewGroupModal = ({ setIsPublicLinkModalOpen, onUpdate }) => {
    const [groupName, setGroupName] = useState<string>('');
    const closeModal = () => setIsPublicLinkModalOpen(false);

    const createGroup = async () => {
        if (groupName.length) {
          const groupKey = keyGen();

          await clientDb().update({
            [`groups/${groupKey}`]: {
              'name': groupName,
              'sub-admins': {},
              'sub-users': {}
            }
          });

          await onUpdate();

          closeModal();
        }
    };

    return (
        <Modal className={styles.modal} onBackdropClick={closeModal}>
            <div className={styles.modalContainer}>
                <h1 className={styles.title}>Create New Group</h1>
                <section className={styles.inputSection}>
                    <label htmlFor="groupName">Group Name</label>
                    <input
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        id="groupName"
                        placeholder="Enter group name"
                    />
                </section>

                <footer className={styles.footer}>
                    <button
                      type='button'
                      className={styles.closeButton}
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      type='button'
                      className={styles.createButton}
                      onClick={createGroup}
                      disabled={!groupName}
                    >
                      Create
                    </button>
                </footer>
            </div>
        </Modal>
    )
}

export default CreateNewGroupModal;
